export const LIBRARY_PROJECT_PIPELINE_STAGES = [
  'inbox',
  'screening',
  'interview',
  'offer',
  'hired',
  'rejected',
];
